import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { mockListings } from '../services/mockData';
import ChatWidget from './ChatWidget';

const ListingDetails = () => {
  const { listingId } = useParams();
  const listing = mockListings[listingId];

  if (!listing) {
    return <Navigate to="/" replace />;
  }

  const handleContactClick = () => {
    // Analytics tracking would go here
    console.log('Contact button clicked for:', listing.name);
  };

  return (
    <div className="listing-details">
      <div className="listing-header card">
        <div className="header-image" style={{ backgroundImage: `url(${listing.mainImage})` }}>
          <div className="header-overlay">
            <h1>{listing.name}</h1>
            <div className="rating">
              <span className="stars">{'★'.repeat(Math.floor(listing.rating))}</span>
              <span className="rating-text">
                {listing.rating} ({listing.reviewCount} reviews)
              </span>
            </div>
            <p className="years-in-business">{listing.yearsInBusiness} Years in Business</p>
          </div>
        </div>
      </div>

      <div className="listing-grid">
        <div className="main-content">
          <section className="services-section card">
            <h2>Services</h2>
            <ul className="services-list">
              {listing.services.map((service, index) => (
                <li key={index}>{service}</li>
              ))}
            </ul>
          </section>

          <section className="reviews-section card">
            <h2>Customer Reviews</h2>
            <div className="reviews-list">
              {listing.reviews.map((review) => (
                <div key={review.id} className="review">
                  <div className="review-header">
                    <span className="review-author">{review.author}</span>
                    <span className="review-date">{review.date}</span>
                  </div>
                  <div className="review-rating">{'★'.repeat(review.rating)}</div>
                  <p className="review-content">{review.content}</p>
                </div>
              ))}
            </div>
          </section>
        </div>

        <aside className="sidebar">
          <div className="contact-info card">
            <h2>Contact Information</h2>
            <div className="info-item">
              <strong>Address:</strong>
              <p>{listing.address}</p>
            </div>
            <div className="info-item">
              <strong>Phone:</strong>
              <p>{listing.phone}</p>
            </div>
            <div className="info-item">
              <strong>Email:</strong>
              <p>{listing.email}</p>
            </div>
            <div className="info-item">
              <strong>Website:</strong>
              <p>
                <a href={listing.website} target="_blank" rel="noopener noreferrer">
                  {listing.website}
                </a>
              </p>
            </div>
            <button className="button contact-button" onClick={handleContactClick}>
              Contact Now
            </button>
          </div>

          <div className="business-hours card">
            <h2>Business Hours</h2>
            {Object.entries(listing.hours).map(([day, hours]) => (
              <div key={day} className="hours-item">
                <span className="day">{day.charAt(0).toUpperCase() + day.slice(1)}:</span>
                <span className="hours">{hours}</span>
              </div>
            ))}
          </div>

          <div className="certifications card">
            <h2>Certifications</h2>
            <ul className="certifications-list">
              {listing.certifications.map((cert, index) => (
                <li key={index}>{cert}</li>
              ))}
            </ul>
          </div>
        </aside>
      </div>

      <ChatWidget providerId={listingId} providerName={listing.name} />
    </div>
  );
};

export default ListingDetails;